import React, {Component} from 'react'
export default class TimeDisplay extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  getLabel = () => {
    return this.props.label || ' - '
  }

  getClock = (time) => {
    if (time === null) return null
    if (!this.props.summary) return time.split(':00')[0]
    if (time === 0) return 0
    return time
      .split(':')
      .slice(0, 2)
      .join(':')
  }

  render() {
    const {value} = this.props
    return (
      <span>
        {value.from ? <span>{this.getClock(value.from)}</span> : ''}
        {this.getLabel()}
        {value.to ? <span>{this.getClock(value.to)}</span> : ''}
      </span>
    )
  }
}
